import storage from '@/store/localstorage.js'

const state = {
  id: storage.get('warehouseUserId') || '',
  user_name: storage.get('warehouseUserName') || '',
  email: storage.get('warehouseUserEmail') || ''
}

const getters = {
  id: (state) => {
    return state.id
  },
  data: (state) => {
    return state
  },
  companyName: (state) => {
    return state.user_name
  },
  isLogged: (state) => {
    return !!state.id
  }
}

const mutations = {
  LOGGED_IN (state, data) {
    console.log(data)
    state.id = data.id
    state.user_name = data.name
    state.email = data.email
    storage.set('warehouseUserId', state.id)
    storage.set('warehouseUserName', state.user_name)
    storage.set('warehouseUserEmail', state.email)
  },
  LOGGED_OUT (state) {
    storage.remove('warehouseUserId')
    storage.remove('warehouseUserName')
    storage.remove('warehouseUserEmail')
    state.id = ''
    state.user_name = ''
    state.email = ''
  }
}

const actions = {
  loggedin ({ commit }, payload) {
    return commit('LOGGED_IN', payload)
  },
  logout ({ commit }) {
    return commit('LOGGED_OUT')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
